import { render, staticRenderFns } from "./groupon.vue?vue&type=template&id=441438ae&scoped=true&"
import script from "./groupon.vue?vue&type=script&lang=js&"
export * from "./groupon.vue?vue&type=script&lang=js&"
import style0 from "./groupon.vue?vue&type=style&index=0&id=441438ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441438ae",
  null
  
)

component.options.__file = "groupon.vue"
export default component.exports